// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMChip.tsx — PropelMapper chip. Two modes:
//   selectable filter chip (selected → primary-surface), and
//   removable chip (trailing × calls onRemove).
// Optional leading color dot. Tokens throughout.

const PMCHIP_CSS = `
.pmchip{box-sizing:border-box;display:inline-flex;align-items:center;gap:7px;border:1.5px solid var(--pm-border);background:var(--pm-surface);border-radius:var(--pm-radius-pill,999px);padding:7px 13px;font:var(--pm-label-l);font-weight:600;color:var(--pm-fg-1);cursor:pointer;transition:.12s;font-family:inherit;white-space:nowrap}
.pmchip:hover{border-color:var(--pm-border-dark)}
.pmchip.is-on{background:var(--pm-primary-surface);border-color:var(--pm-primary-light);color:var(--pm-primary-dark)}
.pmchip.is-static{cursor:default}
.pmchip.is-static:hover{border-color:var(--pm-border)}
.pmchip-dot{width:9px;height:9px;border-radius:50%;flex:0 0 9px}
.pmchip-x{display:grid;place-items:center;width:18px;height:18px;border-radius:50%;cursor:pointer;color:inherit;margin-right:-4px;border:none;background:none;padding:0}
.pmchip-x:hover{background:rgba(0,0,0,.10)}
`;
function pmchipEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmchip-css")) return;
  const s = document.createElement("style"); s.id = "pmchip-css"; s.textContent = PMCHIP_CSS;
  document.head.appendChild(s);
}

const pmchipGlyphVars: any = { "--icon-fg": "currentColor", "--icon-accent": "currentColor" };
function pmchipGlyph(base, size, cls = "") {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base] ? base : (I[base + "-outline"] ? base + "-outline" : null);
  if (name) return <span className={"pm-icon " + cls} aria-hidden="true"
    style={Object.assign({ width: size, height: size }, pmchipGlyphVars)}
    dangerouslySetInnerHTML={{ __html: I[name] }} />;
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 1 }}>{base}</span>;
}
export function PMChip({ label, selected = false, dotColor, onToggle, onRemove, className = "", style = {}, children, ...rest }) {
  pmchipEnsureCSS();
  const removable = typeof onRemove === "function";
  const selectable = typeof onToggle === "function";
  const cls = "pmchip" + (selected ? " is-on" : "") + (!selectable ? " is-static" : "") + (className ? " " + className : "");
  return (
    <span
      className={cls}
      style={style}
      role={selectable ? "button" : undefined}
      aria-pressed={selectable ? selected : undefined}
      onClick={selectable ? () => onToggle(!selected) : undefined}
      {...rest}
    >
      {dotColor ? <span className="pmchip-dot" style={{ background: dotColor }} /> : null}
      {label != null ? label : children}
      {removable ? (
        <button type="button" className="pmchip-x" aria-label="Remove"
          onClick={(e) => { e.stopPropagation(); onRemove(); }}>
          {pmchipGlyph("close", 13)}
        </button>
      ) : null}
    </span>
  );
}
